import { COLORS, HALO } from "../../../../constants";
export var datepickerStyles = {
    p: 6,
    // content area
    ".MuiDateCalendar-root": {
        width: 284,
    },
    ".MuiPickersSlideTransition-root": {
        minHeight: 220,
    },
    // Month year display
    ".MuiPickersCalendarHeader-label": {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "600",
        position: "relative",
        zIndex: 2,
        py: 1.5,
        borderRadius: "100px",
        px: 4,
        "&:hover": {
            bgcolor: COLORS.SECONDARY_HOVER,
        },
        "&:focus-visible": {
            boxShadow: HALO,
        },
        "&:active": {
            bgcolor: COLORS.SECONDARY_PRESSED,
        },
    },
    // wrapper of header with date display and arrows
    ".MuiPickersCalendarHeader-root": {
        justifyContent: "center",
        position: "relative",
        height: 36,
        px: 6,
        maxHeight: 36,
        mt: 0,
        mb: 6,
    },
    // date display
    ".MuiPickersCalendarHeader-labelContainer": {
        margin: 0,
    },
    // arrows
    ".MuiPickersArrowSwitcher-root": {
        position: "absolute",
        width: "100%",
        top: 0,
        height: "36px",
        justifyContent: "space-between",
        alignItems: "center",
        opacity: "1 !important",
        visibility: "visible !important",
    },
    ".MuiIconButton-edgeEnd": {},
    ".MuiIconButton-edgeStart": {},
    // days
    ".MuiPickersDay-root": {
        width: 32,
        height: 32,
        mx: "5px",
        fontSize: "14px",
        lineHiehgt: "20px",
        "&:focus-visible": {
            boxShadow: HALO,
        },
        "&:last-child": {
            mr: 0,
        },
        "&:first-of-type": {
            ml: 0,
        },
        "&.hover": {
            background: COLORS.SECONDARY_HOVER,
        },
        "&.MuiPickersDay-today": {
            border: "1px solid ".concat(COLORS.SAY_COBALT),
        },
        "&.MuiPickersDay-dayOutsideMonth:not(.Mui-selected)": {
            color: COLORS.P_MED_LOW_EMPHASIS,
        },
    },
    // week row
    ".MuiDayCalendar-weekContainer": {
        my: 3,
        "&:last-child": {
            my: 0,
        },
        "&:first-of-type": {
            mb: 0,
        },
    },
    // weekday names
    ".MuiDayCalendar-weekDayLabel": {
        height: 32,
        width: 32,
        fontSize: "14px",
        lineHeight: "20px",
        color: COLORS.P_MED_LOW_EMPHASIS,
        mx: "5px",
        "&:last-child": {
            mr: 0,
        },
        "&:first-of-type": {
            ml: 0,
        },
    },
    // month
    ".MuiPickersMonth-root": {
        width: "auto",
        flexBasis: "auto",
        mt: 3,
        "&:nth-of-type(-n + 3)": {
            mt: 0,
        },
        "&:nth-of-type(3n + 2)": {
            mx: 14.5,
        },
    },
    ".MuiPickersMonth-monthButton": {
        width: 56,
        height: 36,
        fontWeight: 400,
        m: 0,
        "&:focus-visible": {
            boxShadow: HALO,
        },
        "&:active": {
            bgcolor: COLORS.SECONDARY_PRESSED,
        },
    },
    ".MuiMonthCalendar-root": {
        width: "100%",
        p: 0,
    },
};
